import { NavLink } from "react-router";
import { useData } from "@/context/data-provider";

const tabs = [
  { to: "/", icon: "📊", label: "Dashboard", end: true },
  { to: "/plano", icon: "📝", label: "Plano" },
  { to: "/agenda", icon: "📆", label: "Agenda" },
  { to: "/medicos", icon: "👨‍⚕️", label: "Médicos" },
  { to: "/cobertura", icon: "📈", label: "Cobertura" },
  { to: "/analise", icon: "📉", label: "Análise" },
  { to: "/apoios", icon: "🤝", label: "Apoios" },
  { to: "/todo", icon: "✅", label: "To Do" },
  { to: "/periodo", icon: "🗓", label: "Período" },
  { to: "/configuracoes", icon: "⚙️", label: "Config" },
] as const;

export function BottomNav() {
  const { todos: { todos } } = useData();
  const pendingCount = todos.filter((t) => !t.done).length;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-[500] bg-white flex overflow-x-auto"
      style={{
        borderTop: "1px solid var(--mv-border)",
        paddingBottom: "env(safe-area-inset-bottom)",
        boxShadow: "0 -2px 14px rgba(15,46,90,0.09)",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {tabs.map(({ to, icon, label, ...rest }) => (
        <NavLink
          key={to}
          to={to}
          end={"end" in rest}
          className={({ isActive }) =>
            `bottom-nav-item flex flex-col items-center justify-center py-[7px] pb-[5px] min-w-[62px] flex-1 flex-shrink-0 gap-[3px] no-underline ${isActive ? "active" : ""}`
          }
        >
          {({ isActive }) => (
            <>
              <span
                className="text-[1.35rem] leading-none transition-transform duration-150"
                style={{ transform: isActive ? "scale(1.12)" : undefined }}
              >
                {icon}
              </span>
              <span
                className="font-mono text-[0.52rem] whitespace-nowrap transition-colors duration-150"
                style={{
                  color: isActive ? "var(--mv-blue)" : "var(--mv-ink-xlight)",
                  fontWeight: isActive ? 700 : 500,
                }}
              >
                {label}
              </span>
              {label === "To Do" && pendingCount > 0 && (
                <span
                  className="absolute font-mono text-[0.48rem] font-bold min-w-[14px] h-[14px] rounded-full flex items-center justify-center px-[3px]"
                  style={{
                    top: 4,
                    right: "calc(50% - 20px)",
                    background: "var(--mv-red)",
                    color: "#fff",
                    border: "2px solid #fff",
                  }}
                >
                  {pendingCount}
                </span>
              )}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
